import PropTypes from "prop-types";
import clsx from "clsx";
import { Link, useNavigate } from "react-router-dom";
import { IoCall } from "react-icons/io5";
import { IoIosMail } from "react-icons/io";
import { FaLocationDot } from "react-icons/fa6";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getBranchs } from "../../store/actions/Branch";

const FooterCopyright = ({ footerLogo, spaceBottomClass, colorClass }) => {
  const branchs = useSelector((state) => state.branchs.list) || [];
  const dispatch = useDispatch();

  useEffect(() => {
    const fetchBranchs = async () => {
      await dispatch(getBranchs());
    };
    fetchBranchs();
  }, [dispatch]);

  const navigate = useNavigate()
  const staticBranches = [
    {
      name: "Central Bazaar Branch",
      image: "assets/img/svg/Iphone12White.jpg",
    },
    {
      name: "Katargam Branch",
      image: "assets/img/svg/Iphone12Blue.jpg",
    },
    {
      name: "Hirabaugh Branch",
      image: "assets/img/svg/Iphone12Red.jpg",
    },
  ];

  // Normalize static names for matching
  const normalizeName = (name) =>
    name.toLowerCase().replace(/\s+/g, "").replace("branch", "");

  const mergedBranches = branchs
    .filter((branch) => branch.status === 1)
    .map((branch) => {
      const matchedStatic = staticBranches.find((staticBranch) =>
        normalizeName(staticBranch.name).includes(normalizeName(branch.name))
      );

      return {
        _id: branch._id,
        name: branch.name,
        address: branch.address,
        phone: "+91 7896541230", // Customize if needed or use branch.phone if exists
        image: matchedStatic?.image,
        location: branch.location,
      };
    });

  const [selectedBranch, setSelectedBranch] = useState(null);

  // Set initial selected branch once mergedBranches loads
  useEffect(() => {

    setSelectedBranch(mergedBranches[0]);

  }, [branchs]);

  const handleSelectBranch = (branchId) => {
    const found = mergedBranches.find((b) => b._id === branchId);
    if (found) {
      setSelectedBranch(found);
    }
  };

  const encodedAddress = encodeURIComponent(selectedBranch?.address || "");

  return (
    <div className={clsx("copyright", spaceBottomClass, colorClass)}>
      <div className="footer-logo">
        <Link to={process.env.PUBLIC_URL + "/"}>
          <img alt="" src={footerLogo || "assets/img/svg/footerLogo.png"} />
        </Link>
      </div>

      <div
        style={{ display: "flex", gap: "20px", color: "white" }}
      >
        {/* Branch Selector */}
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            flexDirection: "column",
            gap: "20px",

          }}
        >
          {mergedBranches.slice(0, 3).map((branch) => (
            <span
              key={branch._id}
              onClick={() => handleSelectBranch(branch._id)}
              style={{
                padding: "5px 10px",
                backgroundColor:
                  selectedBranch?._id === branch._id ? "#00aaff" : "transparent",
                borderRadius: "4px",
                transition: "0.3s",
                cursor: "pointer",
              }}
            >
              {branch.name}
            </span>
          ))}
        </div>

        {/* Branch Info */}
        {selectedBranch && (
          <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
            <a
              href={`tel:${selectedBranch.phone.replace(/\s+/g, "")}`}
              style={{
                display: "flex",
                alignItems: "center",
                gap: "10px",
                color: "white",
                textDecoration: "none",
              }}
            >
              <IoCall /> {selectedBranch.phone}
            </a>

            <a
              href="mailto:info@09mobilegallery.com"
              style={{
                display: "flex",
                alignItems: "center",
                gap: "10px",
                color: "white",
                textDecoration: "none",
              }}
            >
              <IoIosMail /> info@09mobilegallery.com
            </a>

            <a
              href={`https://www.google.com/maps/search/?api=1&query=${encodedAddress}`}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                display: "flex",
                alignItems: "flex-start",
                color: "white",
                textDecoration: "none",
                lineHeight: "1.6em",
              }}
            >
              <FaLocationDot style={{ marginRight: "8px", marginTop: "4px" }} />
              <div>{selectedBranch.address}</div>
            </a>
          </div>
        )}

      </div>
      <button style={{ backgroundColor: "white", textAlign: "center", backgroundColor: "#00aaff", height: "30px", width: "50px", color: "white", borderRadius: "10px", border: "none" }} className="mt-2" onClick={() => { navigate("/branch") }}>+{mergedBranches.length - 3} </button>
    </div>
  );
};

FooterCopyright.propTypes = {
  footerLogo: PropTypes.string,
  spaceBottomClass: PropTypes.string,
  colorClass: PropTypes.string,
};

export default FooterCopyright;
